export const LOGIN_HISTORY = 'LOGIN_HISTORY';
export const LOGIN_HISTORY_FAILED = 'LOGIN_HISTORY_FAILED';
export const LOGIN_HISTORY_SUCCEED = 'LOGIN_HISTORY_SUCCEED';

export const USER_LIST = 'USER_LIST';
export const USER_LIST_FAILED = 'USER_LIST_FAILED';
export const USER_LIST_SUCCEED = 'USER_LIST_SUCCEED';

export const USER_BALANCES = 'USER_BALANCES';
export const USER_BALANCES_FAILED = 'USER_BALANCES_FAILED';
export const USER_BALANCES_SUCCEED = 'USER_BALANCES_SUCCEED';

export const LOGOUT = 'LOGOUT';
export const LOGOUT_SUCCEED = 'LOGOUT_SUCCEED';
export const LOGOUT_FAILED = 'LOGOUT_FAILED';

export const CLEAR_USER_DATA = 'CLEAR_USER_DATA';

export const USER_INFO = 'USER_INFO';
export const USER_INFO_FAILED = 'USER_INFO_FAILED';
export const USER_INFO_SUCCEED = 'USER_INFO_SUCCEED';

export const USER_LOGIN_HISTORY = 'USER_LOGIN_HISTORY';
export const USER_LOGIN_HISTORY_FAILED = 'USER_LOGIN_HISTORY_FAILED';
export const USER_LOGIN_HISTORY_SUCCEED = 'USER_LOGIN_HISTORY_SUCCEED';

export const USER_LIST_ADDRESS = 'USER_LIST_ADDRESS';
export const USER_LIST_ADDRESS_FAILED = 'USER_LIST_ADDRESS_FAILED';
export const USER_LIST_ADDRESS_SUCCEED = 'USER_LIST_ADDRESS_SUCCEED';

export const USER_SYSTEM_LIST = 'USER_SYSTEM_LIST';
export const USER_SYSTEM_LIST_FAILED = 'USER_SYSTEM_LIST_FAILED';
export const USER_SYSTEM_LIST_SUCCEED = 'USER_SYSTEM_LIST_SUCCEED';

export const USER_SYSTEM_INFO = 'USER_SYSTEM_INFO';
export const USER_SYSTEM_INFO_FAILED = 'USER_SYSTEM_INFO_FAILED';
export const USER_SYSTEM_INFO_SUCCEED = 'USER_SYSTEM_INFO_SUCCEED';

export const LOCK_USER = 'LOCK_USER';
export const LOCK_USER_SUCCEED = 'LOCK_USER_SUCCEED';
export const LOCK_USER_FAILED = 'LOCK_USER_FAILED';

export const UNLOCK_USER = 'UNLOCK_USER';
export const UNLOCK_USER_SUCCEED = 'UNLOCK_USER_SUCCEED';
export const UNLOCK_USER_FAILED = 'UNLOCK_USER_FAILED';
